// @flow
import getConfigs from 'next/config';

const defaultNextConfig = { publicRuntimeConfig: {} };

const { publicRuntimeConfig }: any = getConfigs() || defaultNextConfig;

export const nextConfig = publicRuntimeConfig;
